export const mapSprintListToOptions = (list = []) =>
    (list || []).map((item) => ({
        label: item?.title || 'Untitled Sprint',
        value: item?._id,
    }))

export const getSprintDisplayOptionFromTask = (task) => {
    const raw = task?.sprint ?? task?.sprintId
    const record = Array.isArray(raw)
        ? raw[0]
        : raw && typeof raw === 'object' && (raw._id || raw.id)
          ? raw
          : null
    if (!record) return null
    const id = record._id ?? record.id
    if (id == null || id === '') return null
    return {
        label: record?.title || record?.name || 'Untitled Sprint',
        value: id,
    }
}
